import { render, staticRenderFns } from "./GuardiaV1.vue?vue&type=template&id=0ecfb354&"
import script from "./GuardiaV1.vue?vue&type=script&lang=js&"
export * from "./GuardiaV1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports